import React from 'react';
import { Box } from '@mui/material';
import { DraggableTooltipContainer } from 'spw-components/worksheet/styles';
import { TooltipTitle, TooltipSection, TooltipText } from './styles';

const DeskSharingGuide: React.FC = () => (
  <DraggableTooltipContainer>
    <TooltipTitle id="draggable-dialog-title" className="title">
      Desk Sharing Ratio Tips
    </TooltipTitle>
    <div className="content">
      <TooltipText>
        How many desks (work seats) are needed per person (headcount)? This
        includes all individual workspaces (i.e. workstations and private
        offices).
      </TooltipText>
      <TooltipSection>High</TooltipSection>
      <TooltipText>1:1.00</TooltipText>
      <TooltipText>1 desk for every 1 person</TooltipText>

      <TooltipSection>Medium</TooltipSection>
      <TooltipText>1:1.25</TooltipText>
      <TooltipText>1 desk for every 1.25 people</TooltipText>

      <TooltipSection>Low</TooltipSection>
      <TooltipText>1:1.40</TooltipText>
      <TooltipText>1 desk for every 1.4 people</TooltipText>

      <Box marginTop="8px">
        <TooltipText>
          If everyone is in the office, and a 1.40 desk sharing ratio is
          applied, there would be enough desks for 71% of them. (ex. 1 / 1.40 =
          71%)
        </TooltipText>
      </Box>

      <Box marginTop="8px">
        <TooltipText>
          If you know the number of work seats but not the sharing ratio, divide
          headcount by work seats to calculate this ratio. (ex. 100 headcount /
          67 work seats = 1.49 desk sharing ratio)
        </TooltipText>
      </Box>
    </div>
  </DraggableTooltipContainer>
);

export default DeskSharingGuide;
